import React, { useState } from 'react';
import {
  Backdrop,
  Box,
  Button,
  Grid,
  Modal,
  Typography,
} from '@material-ui/core';
import { Formik, Field, Form, FieldArray } from 'formik';
import style from '../formik.module.css';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getAllSchoolAsync,
  updateSchoolAgreementAsync,
  updateSchoolDocsAsync,
  uploadFileAsync,
} from '../bccTeenybeansStore/bccTeenybeansStoreSlice';
import CloseIcon from '@material-ui/icons/Close';

const styles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
};

const initialValues = {
  agreementDocuments: [
    {
      docS3Key: '',
      title: '',
      description: '',
    },
  ],
};

function UploadDocuments({ schoolId, type }) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);

  const handleUploadDocument = (e, index, setFieldValue) => {
    const maxSize = 1024 * 1024 * 2;
    if (e.target.files[0].size > maxSize) {
      toast.error('File size exceeds the limit of 2MB');
    } else {
      dispatch(uploadFileAsync({ file: e.target.files[0] }))
        .unwrap()
        .then((res) => {
          setFieldValue(
            `agreementDocuments.${index}.docS3Key`,
            res && res.data && res.data.document
          );
        });
    }
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={() => setOpenModal(true)}>
        Upload Doc.
      </Button>
      <Modal
        className={styles.premiumModal}
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Box sx={styles}>
          <Box display="flex" justifyContent={'space-between'}>
            <Typography variant="h6" component="h2" mb={2}>
              Upload School {type}
            </Typography>
            <Box sx={{ cursor: 'pointer' }}>
              <CloseIcon
                fontSize="medium"
                onClick={() => setOpenModal(false)}
              />
            </Box>
          </Box>
          <Box>
            <Formik
              initialValues={initialValues}
              onSubmit={async (values) => {
                await new Promise((r) => setTimeout(r, 500));
                const payload = {
                  ...values.agreementDocuments[0],
                };
                dispatch(
                  type === 'Agreement'
                    ? updateSchoolAgreementAsync({
                        id: schoolId,
                        data: payload,
                      })
                    : updateSchoolDocsAsync({
                        id: schoolId,
                        data: payload,
                      })
                )
                  .unwrap()
                  .then((res) => {
                    setOpenModal(false);
                    toast.success(`School ${type} Updated Successfully`);
                    dispatch(
                      getAllSchoolAsync({
                        params: { page: 1, limitPerPage: 10 },
                      })
                    );
                  })
                  .catch((err) => {
                    toast.error(err.message);
                  });
              }}
              validate={(values) => {
                const errors = {};
                values.agreementDocuments.forEach((field, index) => {
                  if (
                    field.docS3Key === '' ||
                    field.title === '' ||
                    field.description === ''
                  ) {
                    errors[`agreementDocuments${index}`] = 'Field is required';
                  }
                });
                return errors;
              }}>
              {({ values, setFieldValue }) => (
                <Form>
                  <FieldArray name="agreementDocuments">
                    {({ insert, remove, push }) => (
                      <>
                        {values.agreementDocuments.length > 0 &&
                          values.agreementDocuments.map((document, index) => (
                            <div className="row" key={index}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <label
                                    htmlFor={`agreementDocuments.${index}.title`}>
                                    Title
                                  </label>
                                  <Field
                                    className={style.field}
                                    name={`agreementDocuments.${index}.title`}
                                    type="text"
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <label
                                    htmlFor={`agreementDocuments.${index}.description`}>
                                    Description
                                  </label>
                                  <Field
                                    className={style.field}
                                    name={`agreementDocuments.${index}.description`}
                                    type="text"
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <label
                                    htmlFor={`agreementDocuments.${index}.uploadDocument`}>
                                    Upload a file
                                  </label>
                                  <input
                                    name={`agreementDocuments.${index}.uploadDocument`}
                                    className={style.field}
                                    type={'file'}
                                    onChange={(e) =>
                                      handleUploadDocument(
                                        e,
                                        index,
                                        setFieldValue
                                      )
                                    }
                                  />
                                </Grid>
                                {/* <Grid item xs={12}>
                            <Box textAlign={'right'}>
                              <Button
                                type="button"
                                variant="outlined"
                                className="secondary"
                                onClick={() => remove(index)}>
                                Remove
                              </Button>
                            </Box>
                          </Grid> */}
                              </Grid>
                            </div>
                          ))}
                        {/* <Box mt={-6}>
                    <Button
                      type="button"
                      variant="contained"
                      className="secondary"
                      onClick={() =>
                        push({
                          docS3Key: '',
                          title: '',
                          description: '',
                        })
                      }>
                      Add Documents
                    </Button>
                  </Box> */}
                      </>
                    )}
                  </FieldArray>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Button variant="contained" color="primary" type="submit">
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default UploadDocuments;
